function GroupCreation() {
    return (
        <div>
            <h2>Group Creation</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default GroupCreation;